// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const StyleIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2.53 19.65l1.34.56v-9L1.44 17a2 2 0 001.09 2.65zM22 16L17 4a2 2 0 00-2.6-1.08L7.1 6a2 2 0 00-1.23 1.8 1.87 1.87 0 00.15.8l5 12a2 2 0 001.83 1.23 2.07 2.07 0 00.77-.15l7.36-3.05A2 2 0 0022 16zM7.88 8.75a1 1 0 111-1 1 1 0 01-1 1zm-2 11a2 2 0 002 2h1.45l-3.45-8.34z"/></svg>'} />;

StyleIcon.displayName = 'StyleIcon';

export default StyleIcon;
